import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { applySeo } from "./seoHead";
import { useSeoConfig } from "./useSeoConfig";

/**
 * Keeps the document head in step with the route.
 *
 * The whole site is a single page application, so the head is the only place a crawler can read
 * the page level metadata from. This component rewrites it on every navigation: a public route
 * gets its own title, description, canonical and Open Graph tags, and anything that is not a
 * registered public page is served as `noindex, nofollow`.
 *
 * It renders nothing - it only touches `document.head`.
 */
export default function SeoManager() {
  const location = useLocation();
  const config = useSeoConfig();

  useEffect(() => {
    applySeo(config, location.pathname);
  }, [config, location.pathname]);

  return null;
}
